export enum HTTP_FILTERS {
  GET_PORTS = "/v1/ports",
  GET_VESSELS = "/v1/vessels",
  GET_VESSEL_MANAGERS = "/v1/vessel-managers",
  GET_CUSTOMERS = "/v1/customers",
}
